const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: '多重地址备份与实时监控，确保探花官网入口始终可用，防止用户走失，保障访问安全性。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时更新',
    desc: '探花最新地址每日更新维护，第一时间同步探花新地址变更，让您无需担心入口失效。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '聚合超过3000+探花在线精选内容，覆盖多元化探花资源类型，满足各类浏览偏好。',
  },
  {
    icon: 'ri-eye-line',
    title: '精选推荐',
    desc: '专业编辑团队每日甄选优质探花精选合集，根据热度与品质持续优化推荐内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            平台特色
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feat) => (
              <div
                key={feat.title}
                className="bg-background-100 rounded-lg border border-background-200/60 p-5 text-center hover:border-primary-300 transition-all duration-200 group cursor-default"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                  <i className={`${feat.icon} text-2xl text-accent-600`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}